import { Button, Grid, InputLabel } from "@material-ui/core";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import CustomeDateCalender from "components/CustomDateSelector/DateSelector.js";
import ToastModal from "views/components/ToastModal";
import { headerLabel } from "assets/properties/properties";
import { loanApplicationStatus } from "assets/properties/properties";
import { occupationDetailsActualLoanAmount } from "assets/properties/properties";
import { parseAndSetFlag } from "utils/Utils";
import { creditApiAmountBtCase } from "assets/properties/properties";
import { APPLICATION_SUB_TYPE_PRE_PLEDGE } from "assets/properties/properties";
const PawanTicketDetails = ({
  setNext,
  setBack,
  loanApplicationId,
  editable,
  status,
  classes,
  featureFlags,
  existingLoanData,
  subStatus
}) => {
  const { authToken } = useSelector((state) => state.login.authData);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [sanctionDate, setSanctionDate] = useState(new Date());
  const [loanAccountNumber, setLoanAccountNumber] = useState("");
  const [loanAccountNumberState, setLoanAccountNumberState] = useState("");
  const [ornamentValue, setOrnamentValue] = useState("");
  const [quantity, setQuantity] = useState("");
  const [grossWeight, setGrossWeight] = useState("");
  const [grossWeightState, setGrossWeightState] = useState("");
  const [netWeight, setNetWeight] = useState("");
  const [netWeightState, setNetWeightState] = useState("");
  const [ratePerGram, setRatePerGram] = useState("");
  const [ltv, setLtv] = useState("");
  const [actualLoanAmount, setActualLoanAmount] = useState("");
  const [sanctionedAmount, setSanctionedAmount] = useState("");
  const [sanctionedAmountState, setSanctionedAmountState] = useState("");
  const [totalOutstanding, setTotalOutstanding] = useState("");
  const [totalOutstandingState, setTotalOutstandingState] = useState("");
  const [customerName, setcustomerName] = useState("");
  const [correctBTAmount, setCorrectBTAmount] = useState(false);
  const [creditScore, setCreditScore] = useState("");
   const enabledCreditApiAmountBtCase = Number(featureFlags?.enabledCreditApiAmountBtCase) || creditApiAmountBtCase;
   const enableCreditAssesmentonBtCase = parseAndSetFlag(featureFlags?.enabledCreditAssesmentInBtPrePledge)
  const [otherEmi, setOtherEmi] = useState("");
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    getPawanTicketDetails();
  }, []);
  const getPawanTicketDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.PawanTicket_Detials_get + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!result.data.error_code) {
      updateData(result.data);
    } else {
      updateData(existingLoanData.pawanTicketDetail);
    }
  };

  const updateData = (pawanTicketData) => {
    console.log(pawanTicketData,"fskdjbfsjkd");
    setcustomerName(pawanTicketData?.customerName || "");
    setGrossWeight(pawanTicketData?.grossWeight || "");
    setLoanAccountNumber(pawanTicketData?.loanAccountNumber || "");
    setLtv(pawanTicketData?.ltv || "");
    setNetWeight(pawanTicketData?.netWeight || "");
    setOrnamentValue(pawanTicketData?.ornamentValue || "");
    setQuantity(pawanTicketData?.quantity || "");
    setRatePerGram(pawanTicketData?.ratePerGram || "");
    setSanctionedAmount(pawanTicketData?.sanctionedAmount || "");
    setSanctionDate(pawanTicketData?.sanctionedDate || "");
    setTotalOutstanding(pawanTicketData?.totalOutstanding || "");
    setActualLoanAmount(pawanTicketData?.actualLoanAmount || "");
     if(Number(pawanTicketData?.actualLoanAmount) >= enabledCreditApiAmountBtCase && parseAndSetFlag(featureFlags?.enableCreditScoreApi) && !enableCreditAssesmentonBtCase && subStatus === APPLICATION_SUB_TYPE_PRE_PLEDGE){
        getCreditAssementDetails()
      }
  };
  const handlecanceluser = () => {
    setBack();
  };
  const handleNext = () => {
    setNext();
  };
  const handlecreateuserSubmit = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (isValidated()) {
      setCallInProgress(true);
      //NOMINEE_ADD
      const res = await apiHandler({
        url: endpoint.PawanTicket_Detials_post,
        method: "POST",
        authToken: authToken,
        data: {
          loanApplicationId: loanApplicationId,
          sanctionedDate: sanctionDate,
          loanAccountNumber: loanAccountNumber,
          ornamentValue: ornamentValue,
          quantity: quantity,
          grossWeight: grossWeight,
          netWeight: netWeight,
          ratePerGram: ratePerGram,
          ltv: ltv,
          sanctionedAmount: sanctionedAmount,
          totalOutstanding: totalOutstanding,
          customerName: customerName,
          actualLoanAmount: actualLoanAmount,
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code && res?.data?.error_code === 403) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        toastUpdate("Success", "Create Nominee successfully", true);

        setNext();
      }
    }
  };
  const isValidated = () => {
    if (
      loanAccountNumber === "" ||
      typeof loanAccountNumber === "undefined" ||
      loanAccountNumber === null
    ) {
      setLoanAccountNumberState(true);
    } else {
      setLoanAccountNumberState(false);
    }
    if (
      sanctionedAmount === "" ||
      typeof sanctionedAmount === "undefined" ||
      sanctionedAmount === null
    ) {
      setSanctionedAmountState(true);
    } else {
      setSanctionedAmountState(false);
    }
    if (
      grossWeight === "" ||
      typeof grossWeight === "undefined" ||
      grossWeight === null
    ) {
      setGrossWeightState(true);
    } else {
      setGrossWeightState(false);
    }
    if (
      netWeight === "" ||
      typeof netWeight === "undefined" ||
      netWeight === null
    ) {
      setNetWeightState(true);
    } else {
      setNetWeightState(false);
    }
    if (
      totalOutstanding === "" ||
      typeof totalOutstanding === "undefined" ||
      totalOutstanding === null
    ) {
      setTotalOutstandingState(true);
    } else {
      setTotalOutstandingState(false);
    }
    if (
      loanAccountNumber !== "" &&
      sanctionedAmount !== "" &&
      grossWeight !== "" &&
      netWeight !== "" &&
      totalOutstanding !== "" &&
      sanctionDate !== ""
    ) {
      return true;
    } else {
      return false;
    }
  };

   const getCreditAssementDetails = async (actualLoanAmounts) => {
      setCallInProgress(true)
      const result = await apiHandler({
        url: endpoint.CREDIT_ASSESSMENT_DATA_FIND + loanApplicationId,
        authToken: authToken,
      });
      setCallInProgress(false)
      if(!result?.data?.error_code && (!result?.data?.creditScore || Number(result?.data?.creditScore) === 0)){
        await getCreditScore();
      }else{
        setCreditScore(result?.data?.creditScore)
        setOtherEmi(result?.data?.existingMonthlyEmiObligation) 
      }
    }

    const getCreditScore = async () => {
        setCallInProgress(true)
        const res = await apiHandler({
          url: endpoint.GET_CREDIT_SCORE_AND_EMI + loanApplicationId,
          method: "POST",
          authToken: authToken,
        });
        setCallInProgress(false)
        if (res?.data?.error_code) {
          toastUpdate("Error", res?.data?.user_description, true);
          setCorrectBTAmount(true);
        } else {
          setOtherEmi(res?.data?.existingMonthlyEmiObligation);
          setCreditScore(res?.data?.creditScore)
        }
      };
  const handleDateChange = (date) => {
    setSanctionDate(date);
  };
  const handleActualBtAmount = (e) => {
    if (e < totalOutstanding) {
      toastUpdate(
        "Error",
        "Actual BT Amount is less than Total Outstanding Amount",
        true
      );
      setCorrectBTAmount(true);
    } else if(e >= enabledCreditApiAmountBtCase && parseAndSetFlag(featureFlags?.enableCreditScoreApi) && subStatus === APPLICATION_SUB_TYPE_PRE_PLEDGE){
        getCreditAssementDetails();
        setCorrectBTAmount(false);
      }else{
      setCorrectBTAmount(false);
    }
  };
  const handleChange1 = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setOrnamentValue(e);
    }
  };
  const handleChange2 = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setSanctionedAmount(e);
    }
  };
  const handleChange3 = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setTotalOutstanding(e);
    }
  };
  const handleChange4 = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setActualLoanAmount(e);
    }
  };
  const handleChange5 = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setQuantity(e);
    }
  };
  const handleChange6 = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setGrossWeight(e);
    }
  };
  const handleChange7 = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setNetWeight(e);
    }
  };
  const handleChange8 = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setRatePerGram(e);
    }
  };
  const handleChange9 = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setLtv(e);
    }
  };
  const disableFields =
    existingLoanData?.pawanTicketDetail?.loanAccountNumber ? true : !editable;
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={headerLabel?.pawan}
          subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
          onlyLabel
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Loan Account Number"
              required
              error={loanAccountNumberState}
              value={loanAccountNumber || ""}
              setState={setLoanAccountNumber}
              setError={setLoanAccountNumberState}
              disabled={disableFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Customer Name"
              required
              // error={nomineeAddressState}
              value={customerName || ""}
              setState={setcustomerName}
              // setError={setNomineeAddressState}
              disabled={disableFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <InputLabel className={classes.label} style={{ textAlign: "left" }}>
              Sanction Date
            </InputLabel>
            <CustomeDateCalender
              handleDateChange={handleDateChange}
              selectedDate={sanctionDate ? sanctionDate : null}
              id="date"
              inputProps={{
                disabled: disableFields,
                maxDate: new Date(),
              }}
              style={{ paddingLeft: "0px !important" }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Ornament Value"
              required
              // error={nomineeAgeState}
              value={ornamentValue || ""}
              setState={handleChange1}
              // setError={setNomineeAgeState}
              disabled={disableFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Sanctioned Amount"
              required
              error={sanctionedAmountState}
              value={sanctionedAmount || ""}
              setState={handleChange2}
              setError={setSanctionedAmountState}
              disabled={disableFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Total Outstanding"
              required
              error={totalOutstandingState}
              value={totalOutstanding || ""}
              setState={handleChange3}
              setError={setTotalOutstandingState}
              disabled={disableFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Actual BT advance"
              required
              // error={nomineeAgeState}
              value={actualLoanAmount || ""}
              setState={handleChange4}
              // setError={setNomineeAgeState}
              disabled={disableFields}
              setBlur={handleActualBtAmount}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="No. of ornaments"
              required
              // error={nomineeAgeState}
              value={quantity || ""}
              setState={handleChange5}
              // setError={setNomineeAgeState}
              disabled={disableFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="GrossWeight"
              required
              error={grossWeightState}
              value={grossWeight || ""}
              setState={handleChange6}
              setError={setGrossWeightState}
              disabled={disableFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="NetWeight"
              required
              error={netWeightState}
              value={netWeight || ""}
              setState={handleChange7}
              setError={setNetWeightState}
              disabled={disableFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Rate Per Gram"
              required
              // error={nomineeAgeState}
              value={ratePerGram || ""}
              setState={handleChange8}
              // setError={setNomineeAgeState}
              disabled={disableFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Ltv"
              required
              // error={nomineeAgeState}
              value={ltv || ""}
              setState={handleChange9}
              // setError={setNomineeAgeState}
              disabled={disableFields}
            />
          </Grid>
         {creditScore > 0 && <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Credit Score"
              required
              value={creditScore || ""}
              setState={setCreditScore}
              disabled
            />
          </Grid>}
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ textAlign: "end" }}
          >
            <Button
              size="small"
              className={classes.nextButton1}
              onClick={() => handlecanceluser()}
            >
              Back
            </Button>
            {status === loanApplicationStatus?.inProcess ||
            status === loanApplicationStatus?.aadhaar ||
            status === loanApplicationStatus?.selfiestatus ? (
              <Button
                size="small"
                disabled={callInProgress || correctBTAmount}
                className={classes.nextButton}
                onClick={(event) => handlecreateuserSubmit(event)}
              >
                Next
              </Button>
            ) : (
              <Button
                size="small"
                disabled={callInProgress || correctBTAmount}
                className={classes.nextButton}
                onClick={(event) => handleNext()}
              >
                Next
              </Button>
            )}
          </Grid>
          {callInProgress && (
            <CircularProgresss callInProgress={callInProgress} />
          )}

          {toast && (
            <ToastModal
              toastMessage={toastMessage}
              toastMessageType={toastMessageType}
              toastUpdate={toastUpdate}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
PawanTicketDetails.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  loanApplicationNumber: PropTypes.object,
  editable: PropTypes.object,
};
export default PawanTicketDetails;